import { GraphQLFleetContractsRequester } from '@cobliteam/api-lib';
import type { FleetCompanyContract, FleetCompanyOnboardingStatus } from '@cobliteam/api-lib/src/__generated__/graphql';
import { CONTRACT_READ_PERMISSIONS, usePermissions } from '@cobliteam/permissions';
import { type UseQueryOptions, useQuery } from '@tanstack/react-query';

const FLEET_CONTRACT_KEY = 'FLEET_CONTRACT';
const graphQLRequester = () => new GraphQLFleetContractsRequester();

const useFleetContracts = (fleetId: string, options: Partial<UseQueryOptions<FleetCompanyContract[]>> = {}) => {
  const { isAccessAllowed } = usePermissions();
  const hasPermission = isAccessAllowed(CONTRACT_READ_PERMISSIONS);

  return useQuery<FleetCompanyContract[]>({
    queryKey: [FLEET_CONTRACT_KEY],
    queryFn: () => graphQLRequester().getFleetContracts(fleetId),
    retry: false,
    refetchOnMount: false,
    ...options,
    enabled: hasPermission && (options.enabled ?? true),
  });
};

const useFleetCompanyOnboardingStatus = (fleetId: string, options: Partial<UseQueryOptions<FleetCompanyOnboardingStatus>> = {}) => {
  return useQuery<FleetCompanyOnboardingStatus>({
    queryKey: [FLEET_CONTRACT_KEY, 'onboardingStatus', fleetId],
    queryFn: () => graphQLRequester().getFleetCompanyOnboardingStatus(fleetId),
    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
    ...options,
  });
};

export { useFleetCompanyOnboardingStatus, useFleetContracts };
